export interface GeoJsonPolygon {
  type: 'Polygon';
  coordinates: number[][][];
}

export interface GeoJsonPoint {
  type: 'Point';
  coordinates: [number, number];
}

export function validateGeoJsonPolygon(polygon: GeoJsonPolygon): {
  isValid: boolean;
  error?: string;
} {
  if (polygon.type !== 'Polygon') {
    return { isValid: false, error: 'Type must be "Polygon"' };
  }

  if (!polygon.coordinates || !Array.isArray(polygon.coordinates)) {
    return { isValid: false, error: 'Coordinates must be an array' };
  }

  if (polygon.coordinates.length === 0) {
    return { isValid: false, error: 'Coordinates array cannot be empty' };
  }

  const ring = polygon.coordinates[0];
  if (!Array.isArray(ring) || ring.length < 3) {
    return { isValid: false, error: 'Polygon must have at least 3 points' };
  }

  const firstPoint = ring[0];
  const lastPoint = ring[ring.length - 1];

  if (firstPoint[0] !== lastPoint[0] || firstPoint[1] !== lastPoint[1]) {
    return { isValid: false, error: 'Polygon must be closed (first and last points must be the same)' };
  }

  for (const point of ring) {
    if (!Array.isArray(point) || point.length < 2) {
      return { isValid: false, error: 'Each point must have at least 2 coordinates [lng, lat]' };
    }

    const [lng, lat] = point;
    if (typeof lng !== 'number' || typeof lat !== 'number') {
      return { isValid: false, error: 'Coordinates must be numbers' };
    }

    if (lng < -180 || lng > 180) {
      return { isValid: false, error: 'Longitude must be between -180 and 180' };
    }

    if (lat < -90 || lat > 90) {
      return { isValid: false, error: 'Latitude must be between -90 and 90' };
    }
  }

  return { isValid: true };
}

export function closePolygon(coordinates: number[][]): number[][] {
  if (coordinates.length < 3) {
    return coordinates;
  }

  const firstPoint = coordinates[0];
  const lastPoint = coordinates[coordinates.length - 1];

  if (firstPoint[0] === lastPoint[0] && firstPoint[1] === lastPoint[1]) {
    return coordinates;
  }

  return [...coordinates, [firstPoint[0], firstPoint[1]]];
}
